import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format, fromUnixTime } from 'date-fns';

const Timestamp = (props) => {
  const { value,mode } = props;
  const [timeFormated, setTimeFormated] = useState(value);

  useEffect(() => {
    if (value !== '' && parseInt(value, 10) > 1) {
      let v=value;

      if(mode=="milisecond")
        v=v/1000;
      
      const dateType = fromUnixTime(v) == "Invalid Date" ? new Date(v) : fromUnixTime(v);
      
      setTimeFormated(format(dateType, 'dd/MM/yyyy, H:mma'));
    }else if(value==0)
      setTimeFormated('');
  }, [value]);

  return (
    <div>
      {timeFormated}
    </div>
  );
};

Timestamp.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

Timestamp.defaultProps = {
  value: '',
};

export default Timestamp;
